var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 371.4826,
    width: 279.69846,
    viewBox: "0 0 279.69846 371.48259",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1282.115,-80.289414)",
    id: "g82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m 1420.075,102.162 c 3.922,1.37 6.373,-2.898 9.358,-4.614 55.548,-43.759 161.977,-2.961 124.597,107.121 -27.425,0.014 -54.865,0.245 -82.305,0.115 -0.418,-27.096 -6.006,-23.577 -84.454,-22.811 -6.604,0.173 -11.723,5.22 -14.679,10.699 -1.139,3.85 -0.447,7.988 -0.577,11.954 -27.411,0.534 -54.836,-0.087 -82.247,0.058 -4.451,-6.768 -9.437,-39.418 -7.022,-51.448 1.267,-63.615 82.739,-98.036 137.329,-51.074 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m 1388.584,228.936 c 0.288,-9.834 -0.865,-19.971 0.519,-29.632 21.831,-0.187 43.676,-0.346 65.507,0.087 -0.173,9.877 0.202,19.754 -0.274,29.617 -21.918,-0.115 -43.835,0.029 -65.752,-0.072 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "m 1297.022,223.226 c 0,0 34.514,-1.914 74.98,-1.139 -0.029,4.052 -0.216,8.132 0.303,12.184 6.178,14.33 13.174,11.146 82.925,11.146 6.316,0.317 11.809,-4.182 14.765,-9.459 2.898,-4.095 1.442,-9.329 1.831,-14.001 25.032,0.029 50.064,-0.072 75.11,0.058 -0.707,11.129 8.41,145.155 -68.722,218.48 -15.601,16.301 -38.041,15.829 -42.003,-7.339 1.496,-6.621 14.126,-50.951 8.435,-79.104 -0.57,-53.465 -41.116,-82.694 -47.713,15.76 5.499,69.465 9.871,40.642 8.378,70.712 -2.033,4.47 -5.955,7.844 -10.122,10.31 -7.801,1.543 -16.423,1.139 -22.768,-4.182 -35.478,-29.691 -56.742,-75.875 -67.266,-120.934 -9.987,-38.795 -7.74,-77.802 -8.133,-102.492 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrace);
export default __webpack_public_path__ + "static/media/brace.3a019aa6b42040fa2da10d0ff7b02f72.svg";
export { ForwardRef as ReactComponent };